import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, Shield, Star } from 'lucide-react';
export function Slide8_Investment() {
  return <SlideLayout data-id="element-315">
      <div className="flex flex-col h-full justify-center space-y-12 sm:space-y-16" data-id="element-316">
        <div className="space-y-6 text-center" data-id="element-317">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-318">
            Partnership Structure
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-319">
            Pricing reflects ownership and accountability — not effort or hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto w-full" data-id="element-320">
          {/* Build */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-321">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 flex-1" data-id="element-322">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-323">
                <Shield className="w-6 h-6 text-[#7FE0C3]" data-id="element-324" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-325">
                Build and Implementation
              </h3>
              <p className="text-slate-400 text-sm mb-6" data-id="element-326">One-time setup</p>
              <p className="text-slate-500 text-sm" data-id="element-327">
                System architecture and initial setup
              </p>
            </div>
            <div className="flex items-center justify-center mt-4 px-4 py-2.5 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-328">
              <Star className="w-4 h-4 text-amber-400 mr-2" fill="currentColor" data-id="element-329" />
              <span className="text-amber-400 font-medium text-sm" data-id="element-330">
                Money-Back Guaranteed
              </span>
            </div>
          </motion.div>

          {/* System */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} data-id="element-331">
            <div className="bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-8 relative flex-1" data-id="element-332">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-333" />
              <div className="w-12 h-12 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-6 border border-[#7FE0C3]/20" data-id="element-334">
                <DollarSign className="w-6 h-6 text-[#7FE0C3]" data-id="element-335" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-336">System</h3>
              <p className="text-[#7FE0C3] text-sm mb-6" data-id="element-337">Monthly recurring</p>
              <p className="text-slate-500 text-sm" data-id="element-338">
                Per month + campaign costs
              </p>
            </div>
            <div className="flex items-center justify-center mt-4 px-4 py-2.5 rounded-full bg-amber-500/10 border border-amber-500/30" data-id="element-339">
              <Star className="w-4 h-4 text-amber-400 mr-2" fill="currentColor" data-id="element-340" />
              <span className="text-amber-400 font-medium text-sm" data-id="element-341">
                Month-to-Month Agreement
              </span>
            </div>
          </motion.div>

          {/* Performance */}
          <motion.div className="flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-342">
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 flex-1" data-id="element-343">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-6 border border-slate-700" data-id="element-344">
                <TrendingUp className="w-6 h-6 text-amber-400" data-id="element-345" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-346">
                Performance
              </h3>
              <p className="text-slate-400 text-sm mb-6" data-id="element-347">Success-based</p>
              <p className="text-slate-500 text-sm" data-id="element-348">
                Per rep at 30/60/90 day milestones
              </p>
            </div>
            <div className="bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-xl p-4 mt-4" data-id="element-349">
              <p className="text-[#7FE0C3] text-center font-medium text-sm" data-id="element-350">
                We only win when your reps succeed.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </SlideLayout>;
}